export default __webpack_public_path__ + "ags-logo.png?aff05ebed70662a5b12e0b2fe62d730e";